export enum EAllMasterNames {
    GUDIYA_PRINTING_PRICE_LIST = 'gudiya_printing_price_list',
    GUDIYA_PRINTING_LEDGER_USER = 'gudiya_printing_ledger_user',
    ORDER_HISTORY_USER = 'order_history_user',
}
